import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
 
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
